'use client';

import { type ReactNode, createContext, useContext } from 'react';
import { enableMapSet } from 'immer';
import { useStore } from 'zustand';
import { type GeoforgeStore, createGeoforgeStore } from '@/lib/stores';

export type GeoforgeStoreApi = ReturnType<typeof createGeoforgeStore>;

export const GeoforgeStoreContext = createContext<GeoforgeStoreApi | undefined>(undefined);

export interface GeoforgeStoreProviderProps {
  children: ReactNode;
}

enableMapSet();
export const geoforgeStore = createGeoforgeStore();

export const GeoforgeStoreProvider = ({ children }: GeoforgeStoreProviderProps) => {
  return (
    <GeoforgeStoreContext.Provider value={geoforgeStore}>{children}</GeoforgeStoreContext.Provider>
  );
};

export const useGeoforgeStore = <T,>(selector: (store: GeoforgeStore) => T): T => {
  const geoforgeStoreContext = useContext(GeoforgeStoreContext);

  if (!geoforgeStoreContext) {
    throw new Error('useGeoforgeStore must be used within GeoforgeStoreProvider');
  }

  return useStore(geoforgeStoreContext, selector);
};
